var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-with-buttons',{attrs:{"options":_vm.options},on:{"click":_vm.propagateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }